import { z } from 'zod';

export const createAdminUserSchema = z.object({
  // react-doctor-disable-next-line react-doctor/zod-v4-no-deprecated-error-customization -- z.string('msg')/z.number('msg') is valid Zod 4 string-shorthand for the error message, not the deprecated {required_error} object
  email: z
    .string('El correo electrónico es requerido.')
    .min(1, 'El correo electrónico es requerido.')
    .email('Ingresa un correo electrónico válido.'),
  // react-doctor-disable-next-line react-doctor/zod-v4-no-deprecated-error-customization -- z.string('msg')/z.number('msg') is valid Zod 4 string-shorthand for the error message, not the deprecated {required_error} object
  displayName: z
    .string('El nombre es requerido.')
    .min(2, 'El nombre debe tener al menos 2 caracteres.')
    .max(100, 'El nombre no puede exceder 100 caracteres.'),
  roleId: z.string().min(1, 'El rol es requerido.'),
});

export type CreateAdminUserFormValues = z.infer<typeof createAdminUserSchema>;

export const updateAdminUserSchema = z.object({
  email: z
    .string()
    .min(1, 'El correo electrónico es requerido.')
    .email('Ingresa un correo electrónico válido.'),
  displayName: z
    .string()
    .min(2, 'El nombre debe tener al menos 2 caracteres.')
    .max(100, 'El nombre no puede exceder 100 caracteres.'),
});

export type UpdateAdminUserFormValues = z.infer<typeof updateAdminUserSchema>;

export const setupPasswordSchema = z
  .object({
    token: z.string().min(1, 'El token es requerido.'),
    password: z
      .string()
      .min(8, 'La contraseña debe tener al menos 8 caracteres.')
      .max(100, 'La contraseña no puede exceder 100 caracteres.'),
    confirmPassword: z.string(),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Las contraseñas no coinciden.',
    path: ['confirmPassword'],
  });

export type SetupPasswordFormValues = z.infer<typeof setupPasswordSchema>;
